import TextStyle from '../../styles/text';
import ColorStyle from '../../styles/colors';

const tabs = (checked) => ({
    cursor: 'pointer',
    textAlign: 'center',
    minWidth: 80,
    height: 25,
    display: 'inline-block',
    borderBottom: '2px solid rgb(2, 168, 189)',
    padding: '0px 20px',
    borderBottom: `2px solid ${checked ? '#02A8BD' : 'white'}`,
});
const bodyStyle = {
    padding: 0,
    marginTop: 20,
};
const actionsContainer = {
    padding: '0px 30px 30px 0px',
    borderTop: 0,
};

export default {
    input_hint: {
        ...TextStyle.text_lg_hint,
    },
    input_floating: {
        ...TextStyle.big_text_md,
    },
    input: {
        ...TextStyle.text_lg,
    },
    title: {
        ...TextStyle.modal_title,
        borderBottom: 0,
    },
    actionsContainer,
    title_text: {
        ...TextStyle.big_text_md,
        marginBottom: 6,
        marginTop: 30,
    },
    title_text2: {
        ...TextStyle.big_text_md,
        marginTop: 20,
    },
    text: {
        ...TextStyle.text_xs,
    },
    text_link: {
        ...TextStyle.link_md,
    },
    text_medium: {
        ...TextStyle.text_md,
    },
    bodyStyle,

    contentStyleSmall: {
        maxWidth: 360,
    },
    contentStyleNormal: {
        maxWidth: 660,
    },

    contentStyleSmallError: {
        backgroundColor: '#FBDEE1',
        borderTop: '1px solid #F0485C',
        paddingTop: 20,
        maxWidth: 360,
    },
    clearIcon: {
        color: ColorStyle.fm_icon,
        fontSize: 13,
        cursor: 'pointer',
        float: 'right',
    },
    tabs,
    tabsIcon: {
        fontSize: 18,
        marginRight: 7,
    },
    tabsText: {
        ...TextStyle.text_md,
        textTransform: 'uppercase',
        position: 'relative',
        top: '-3px',
    },
    bodyStyleShare: {
        ...bodyStyle,
        background: '#f0f0f0',
    },
    actionsContainerShare: {
        ...actionsContainer,
        background: '#f0f0f0',
    },
    linkText: {
        ...TextStyle.text_md,
    },
};
